module.exports = __webpack_public_path__ + "img/ESAMIFINANZA_home_3.5befc466.jpg";